import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE, WHATSAPP_MSG } from "../lib/data";

export const FloatingActions = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3" data-testid="floating-actions">
      <motion.a
        href={`https://wa.me/${PHONE.replace("+", "")}?text=${WHATSAPP_MSG}`}
        target="_blank"
        rel="noreferrer"
        data-testid="float-whatsapp"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.92 }}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-black shadow-lg shadow-white/20"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={26} strokeWidth={2} />
      </motion.a>
      <motion.a
        href={`tel:${PHONE}`}
        data-testid="float-call"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.92 }}
        className="flex h-14 w-14 items-center justify-center rounded-full border border-white/30 bg-black text-white shadow-lg shadow-white/10"
        aria-label="Call Adinvo"
      >
        <Phone size={24} strokeWidth={2} />
      </motion.a>
    </div>
  );
};

export default FloatingActions;
